export class GetAutoPayClients {
  static readonly type: string = '[CommonSettingsState] GetAutoPayClients';
  constructor(public forceRefresh = false) {}
}

export class GetUsStates {
  static readonly type: string = '[ConfigState] GetUsStates';
}

export class GetClientCurrencies {
  static readonly type: string = '[CommonSettingsState] GetClientCurrencies';
  constructor(public clientIds: number[]) {}
}
